"use client";

import type { NiceModalHandler } from "@packages/ui";
import { useCallback, useRef } from "react";

export const useModalResolution = ({
  onClose,
  modal,
}: {
  modal: NiceModalHandler<Record<string, unknown>>;
  onClose?: () => void;
}) => {
  const isResolved = useRef(false);

  const resolve = useCallback(
    (value: boolean, callback?: () => void) => {
      if (isResolved.current) return callback?.();

      isResolved.current = true;
      modal.resolve(value);
      callback?.();
    },
    [modal.resolve],
  );

  const onOpenChange = useCallback(
    (value: boolean) => {
      if (value) {
        isResolved.current = false;
        modal.show();
      } else {
        resolve(false);
        try {
          onClose?.();
        } finally {
          modal.hide();
          modal.remove();
        }
      }
    },
    [modal.hide, modal.remove, modal.show, onClose, resolve],
  );

  return { onOpenChange, resolve };
};
